var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-dropdown',{attrs:{"value":_vm.value,"options":_vm.options,"option-value-field":_vm.field,"option-label-field":_vm.field,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b73c1a8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/reports/components/PopulatingFilterDropdown.vue
// module id = null
// module chunks = 